'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utils = {
    skEnvironment: function skEnvironment() {
        return window.document.body.classList.contains('sk');
    },

    getQueryStringParam: function getQueryStringParam(paramName) {
        return this.getParamFromUrl(document.location.href, paramName);
    },
    getParamFromUrl: function getParamFromUrl(url, paramName) {
        var questionMarkIndex = url.indexOf('?');
        if (questionMarkIndex < -1) return '';

        var queryString = url.substring(questionMarkIndex);

        var rex = new RegExp(paramName + '=[^&]+', 'gi');
        var paramAndValue = rex.exec(queryString);
        if (!paramAndValue || paramAndValue.length < 1) return '';

        return unescape(paramAndValue[0].split('=')[1]);
    },
    distinctByParam: function distinctByParam(array, key) {
        return [].concat((0, _toConsumableArray3.default)(new _map2.default((array || []).map(function (item) {
            return [item[key], item];
        })).values()));
    },
    getPhoneCountryCode: function getPhoneCountryCode(collection, deliveryTypeId) {
        if (!collection || !deliveryTypeId) return null;

        var deliveryTypeObject = collection.find(function (dt) {
            return dt.id === deliveryTypeId;
        });
        if (!deliveryTypeObject) return null;

        return deliveryTypeObject.phoneCountryCode;
    }
};

exports.default = utils;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/utils.js
// module id = 1202
// module chunks = 0